"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadableField = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReadableField = exports.ReadableField = function ReadableField(_ref) {
  var value = _ref.value,
      label = _ref.label,
      _ref$additionalClassN = _ref.additionalClassName,
      additionalClassName = _ref$additionalClassN === undefined ? "" : _ref$additionalClassN,
      style = _ref.style,
      _ref$dataTest = _ref.dataTest,
      dataTest = _ref$dataTest === undefined ? "default-data-test" : _ref$dataTest;

  var verticalAlignText = {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    flexDirection: "column"
  };

  return _react2.default.createElement(
    "div",
    { className: "readable-field display-inline-block " + additionalClassName,
      "data-testid": dataTest,
      style: style,
      key: label
    },
    label && _react2.default.createElement(
      "div",
      { className: "label margin-bottom-5" },
      label
    ),
    _react2.default.createElement(
      "div",
      { className: "padding-horizontal-10 disclaimer background-transparent height-38 border-arsenic border-all-1 border-radius-4 width-120",
        style: verticalAlignText },
      _react2.default.createElement(
        "span",
        null,
        value
      )
    )
  );
};